import React from 'react'

import AppBar from 'material-ui/AppBar';
import FlatButton from 'material-ui/FlatButton';

import api from '../iCONSAPI'
import { timeout } from '../utils'

const None = () => null

export default class ActionBar extends React.Component {
  constructor(props) {
    super(props)
    this.onLogout = props.onLogout
    this.state = {
      isLogoutButtonEnabled: props.isLoggedIn,
      isLoggedIn: props.isLoggedIn
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isLoggedIn !== this.state.isLoggedIn) {
      this.setState({
        isLogoutButtonEnabled: nextProps.isLoggedIn,
        isLoggedIn: nextProps.isLoggedIn
      })
    }
  }

  doLogout = () => {
    console.log("Try to logout")
    timeout(api.timeout_ms, api.logout())
      .then(response => {
        console.log(response)
        if (response.ok) {
          console.log("OK")
          this.onLogout()
        } else {
          console.log("FAIL")
          // TODO: Handle 403
          this.setState({isLogoutButtonEnabled: true})
        }
      })
      .catch(error => {
        console.log(error.message)
        this.setState({isLogoutButtonEnabled: true})
      })
  }

  handleLogout = () => {
    this.setState({isLogoutButtonEnabled: false})
    this.doLogout()
  }

  render() {
    return (
      <AppBar
        className="top-bar"
        title="iCONS"
        showMenuIconButton={false}
        iconElementRight={this.state.isLoggedIn ? (
          <FlatButton
            disabled={!this.state.isLogoutButtonEnabled}
            label="Logout"
          />
        ) : (
          <None/>
        )}
        onRightIconButtonTouchTap={this.handleLogout}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ActionBar.js